<template>
    <div>
        <ol class="breadcrumb pull-right">
			<li class="breadcrumb-item"><a href="javascript:;">Home</a></li>
			<li class="breadcrumb-item active">Vehicle Detail</li>
		</ol>

        <h1 class="page-header">Vehicle Detail</h1>
        <hr>

         <panel class="border border-secondary" :noExpand="true">
            <template slot="header">
                <h4 class="panel-title">Filter Option</h4>
            </template>
            <div class="row mb-2">
                <div class="col-lg-3 col-xs-12 mb-2" >
                    <div class="row h-100">
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <button type="button" class="btn btn-outline-secondary dropdown-toggle h-100" data-toggle="dropdown">
                                    {{searchOption.text[searchOption.selectedIndex]}} ▼
                                </button>
                                <div class="dropdown-menu">
                                    <a class="dropdown-item searchOptions"
                                    v-for="(option, index) in searchOption.value"
                                    @click="searchOption.selectedIndex = index">{{searchOption.text[index]}}</a>
                                </div>
                            </div>
                            <input type="text" class="form-control h-100" v-model="searchString" placeholder="Enter here">
                        </div>
                        <!-- <div class="input-group-append col-sm-9 col-xs-12 pl-0">
                            <input type="text" class="form-control" v-model="filter.frame_no"/>
                        </div> -->
                        <!-- <div class="text-muted f-w-600 mt-2 " style="margin-left:1%">compared to <span id="daterange-prev-date">{{comparisonDate.startDate.format("DD MMMM YYYY")}} - {{comparisonDate.endDate.format("DD MMMM YYYY")}}</span></div> -->
                    </div>
                </div>
                <div class="col-lg-3 col-xs-12 mb-2" >
                    <div class="row">
                        <label for="staticEmail" class="col-sm-3 col-form-label col-xs-12"  style="padding-left:0; margin: auto 0">Vehicle Type</label>
                        <div class="input-group-append col-sm-9 col-xs-12 pl-0">
                            <!-- <input type="text" class="form-control" v-model="filter.type"/> -->
                            <!-- <select class="form-control" v-model="filter.type">
                                <option disabled value="">--Select Vehicle Type--</option>
                                <option v-for="vehicleType in filterOption.vehicleTypes">{{vehicleType.type}}</option>
                            </select> -->
                            <MultiSelect v-model="filter.type"
                            :options="filterOption.vehicleTypes"
                            :searchable="true"
                            :close-on-select="true"
                            :show-labels="false"
                            :multiple="false"
                            placeholder="Choose Type"></MultiSelect>
                        </div>
                        <!-- <div class="text-muted f-w-600 mt-2 " style="margin-left:1%">compared to <span id="daterange-prev-date">{{comparisonDate.startDate.format("DD MMMM YYYY")}} - {{comparisonDate.endDate.format("DD MMMM YYYY")}}</span></div> -->
                    </div>
                </div>
                <div class="col-lg-3 col-xs-12 mb-2" >
                    <div class="row">
                        <label for="staticEmail" class="col-sm-3 col-form-label col-xs-12"  style="padding-left:0; margin: auto 0">Location</label>
                        <div class="input-group-append col-sm-9 col-xs-12 pl-0">
                            <!-- <input type="text" class="form-control" v-model="filter.type"/> -->
                            <!-- <select class="form-control" v-model="filter.location">
                                <option disabled value="">--Select Vehicle Location--</option>
                                <option v-for="location in filterOption.location">{{location}}</option>
                            </select> -->
                            <MultiSelect v-model="filter.location"
                            :options="filterOption.location"
                            :searchable="true"
                            :close-on-select="true"
                            :show-labels="false"
                            :multiple="false"
                            placeholder="Choose Location"></MultiSelect>
                        </div>
                        <!-- <div class="text-muted f-w-600 mt-2 " style="margin-left:1%">compared to <span id="daterange-prev-date">{{comparisonDate.startDate.format("DD MMMM YYYY")}} - {{comparisonDate.endDate.format("DD MMMM YYYY")}}</span></div> -->
                    </div>
                </div>
                <div class="col-lg-3 col-xs-12 mb-2" >
                    <div class="row">
                        <label for="staticEmail" class="col-sm-3 col-form-label col-xs-12"  style="padding-left:0; margin: auto 0">Color</label>
                        <div class="input-group-append col-sm-9 col-xs-12 pl-0">
                            <!-- <input type="text" class="form-control" v-model="filter.type"/> -->
                            <!-- <select class="form-control" v-model="filter.location">
                                <option disabled value="">--Select Vehicle Location--</option>
                                <option v-for="location in filterOption.location">{{location}}</option>
                            </select> -->
                            <MultiSelect v-model="selected.color"
                            :options="filterOption.color"
                            track-by="color_code"
                            label="color_desc"
                            :searchable="true"
                            :close-on-select="true"
                            :show-labels="false"
                            :multiple="false"
                            placeholder="Choose Color"></MultiSelect>
                        </div>
                        <!-- <div class="text-muted f-w-600 mt-2 " style="margin-left:1%">compared to <span id="daterange-prev-date">{{comparisonDate.startDate.format("DD MMMM YYYY")}} - {{comparisonDate.endDate.format("DD MMMM YYYY")}}</span></div> -->
                    </div>
                </div>
            </div>
            <div class="row ">
                <div class="col-lg-4 col-md-8 col-xs-12 mb-2" >
                    <div class="row">
                        <div class="col-sm-3 col-xs-12" style="display: flex;">
                            <input type="checkbox" value="" style="margin: auto 5px" v-model="dateNotDisabled">
                            <label  style="margin: auto 0">Date</label>
                            <!-- <input class="form-check-input" type="checkbox" value="" id="defaultCheck1" style="margin:auto 0">
                            <label for="staticEmail" class="col-form-label"  style="padding-left:0">Date</label> -->
                        </div>
                        <div class="input-group-append col-sm-9 col-xs-12 pl-0">
                            <date-range-picker id="dateTimeInput" v-model="dateRange" style="width:100%;" :class="{'disabled-picker' : !dateNotDisabled}">
                                <div slot="input" class="text-center" slot-scope="picker" opens="right" >
                                    <i class="fa fa-calendar fa-fw text-white-transparent-5 ml-n1"></i> 
                                    {{ moment(dateRange.startDate).format("DD MMMM YYYY")}} - {{ moment(dateRange.endDate).format("DD MMMM YYYY")}}
                                    <b class="caret"></b>
                                    
                                </div>
                            </date-range-picker>
                            <label for="dateTimeInput" class="input-group-text">
                                <i class="fa fa-calendar"></i>
                            </label>
                        </div>
                        <!-- <div class="text-muted f-w-600 mt-2 " style="margin-left:1%">compared to <span id="daterange-prev-date">{{comparisonDate.startDate.format("DD MMMM YYYY")}} - {{comparisonDate.endDate.format("DD MMMM YYYY")}}</span></div> -->
                    </div>
                </div>
                <div class="col-lg-2 col-md-8 col-xs-12 mb-2" >
                    <div class="row">
                        <label for="staticEmail" class="col-sm-3 col-form-label col-xs-12"  style="padding-left:0">Start</label>
                        <div class="input-group-append col-sm-9 col-xs-12 pl-0">
                            <vue-timepicker format="HH:mm" input-class="form-control h-100" input-width="100%" v-model="selected.start_hour" placeholder="Time Start (Default 00:00)" :class="{'disabled-picker' : !dateNotDisabled}"></vue-timepicker>
                        </div>
                        <!-- <div class="text-muted f-w-600 mt-2 " style="margin-left:1%">compared to <span id="daterange-prev-date">{{comparisonDate.startDate.format("DD MMMM YYYY")}} - {{comparisonDate.endDate.format("DD MMMM YYYY")}}</span></div> -->
                    </div>
                </div>
                <div class="col-lg-2 col-md-8 col-xs-12 mb-2" >
                    <div class="row">
                        <label for="staticEmail" class="col-sm-3 col-form-label col-xs-12"  style="padding-left:0">End</label>
                        <div class="input-group-append col-sm-9 col-xs-12 pl-0">
                            <vue-timepicker format="HH:mm" input-class="form-control h-100" input-width="100%"  v-model="selected.end_hour" placeholder="Time End (Default 23:59)" :class="{'disabled-picker' : !dateNotDisabled}"></vue-timepicker>
                        </div>
                        <!-- <div class="text-muted f-w-600 mt-2 " style="margin-left:1%">compared to <span id="daterange-prev-date">{{comparisonDate.startDate.format("DD MMMM YYYY")}} - {{comparisonDate.endDate.format("DD MMMM YYYY")}}</span></div> -->
                    </div>
                </div>
                <div class="col-lg-4 col-xs-12" style="display: flex; justify-content: center;">
                    <input type="button" class="btn btn-primary float-right" style="width: 65%" @click="search()" value="Search"></input>
                </div>
            </div>
        </panel>
        

        <!--Line Chart-->
        <!-- <successVsfailChart class="mt-3" v-if="filterReady"></successVsfailChart> -->


        <!---Table Report Log Start-->
        <mappingTable class="mt-4" v-if="filterReady"></mappingTable>
    </div> 
</template>

<script>
    import DateRangePicker from "vue2-daterange-picker";
    import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
    import moment from 'moment';
    import * as am4core from "@amcharts/amcharts4/core";
    import VueTimepicker from 'vue2-timepicker/dist/VueTimepicker.umd.min.js'
    import MultiSelect from 'vue-multiselect';
    import $ from 'jquery'

    // import child components
    import mappingTable from './childComponents/mappingTable'
    
    export default{
        data(){
            var startDate = moment().startOf('month')._d;
            // var compareDate = {
            //     startDate :  new moment().subtract(1, 'months').date(1),
            //     endDate : new moment().date(0)
            // }

            var filter = {
                // start_date  : moment(startDate).format('YYYY-MM-DD'),
                // end_date : new moment().format('YYYY-MM-DD'),
                // frame_no : '',
                // qrcode : '',
                type : '',
                location : '',
                color : '',
                // start_hour : "00:00",
                // end_hour : "23:59"
            }

            return{
                moment : moment,
                dateRange: {
                    startDate : startDate,
                    endDate : new moment()._d
                },
                format: moment.localeData().longDateFormat('L'),
                dateNotDisabled : false,
                filter : filter,
                filterReady : false,
                searchButton : false,
                searchString : '',
                searchOption : {
                    selectedIndex : 0,
                    value : ['frame_no', 'qrcode'],
                    text : ['Frame No', 'QR Code']
                },
                selected : {
                    color : null,
                    start_hour : "00:00",
                    end_hour : "23:59",
                },
                filterOption : {
                    vehicleTypes : [],
                    location : [],
                    color : [],
                },
                
            }
        },
        components : {
            DateRangePicker,
            mappingTable,
            VueTimepicker,
            MultiSelect,
        },
        beforeDestroy(){
            am4core.disposeAllCharts();
            this.$store.state.filterUrl = '';
        },
        watch : {
            dateRange : function(){
                let start_date = moment(this.dateRange.startDate).format('YYYY-MM-DD');
                let end_date = moment(this.dateRange.endDate).format('YYYY-MM-DD');
                if(this.dateNotDisabled){
                    this.filter.start_date = start_date;
                    this.filter.end_date = end_date;
                } else {
                    delete this.filter.start_date;
                    delete this.filter.end_date;
                }
                this.initialiseFilter();
            },
            'dateNotDisabled' : function(){

                if(this.dateNotDisabled){
                    $('.form-control[readonly]').css('background-color' , 'white')
                    $('.reportrange-text').css('background-color' , 'white')
                    let start_date = moment(this.dateRange.startDate).format('YYYY-MM-DD');
                    let end_date = moment(this.dateRange.endDate).format('YYYY-MM-DD');

                    this.filter.start_date = start_date;
                    this.filter.end_date = end_date;
                    this.filter.start_hour = this.selected.start_hour;
                    this.filter.end_hour = this.selected.end_hour;
                } else {
                    $('.form-control[readonly]').css('background-color' , '#DCDCDC')
                    $('.reportrange-text').css('background-color' , '#DCDCDC')
                    delete this.filter.start_date;
                    delete this.filter.end_date;
                    delete this.filter.start_hour;
                    delete this.filter.end_hour;
                }
            },
            'selected.color' : function(){
                if(this.selected.color)
                    this.filter.color = this.selected.color.color_code;
                else
                    this.filter.color = null;
            },
            'selected.start_hour' : function(){
                this.filter.start_hour = this.selected.start_hour;
            },
            'selected.end_hour' : function(){
                this.filter.end_hour = this.selected.end_hour;
            },
            'searchOption.selectedIndex' : function(){
                for (var i = 0; i < this.searchOption.value.length; i++){
                    if(this.searchOption.selectedIndex != i || this.searchString == ''){
                        delete this.filter[this.searchOption.value[i]]
                    } else {
                        this.filter[this.searchOption.value[i]] = this.searchString;
                    }
                }
            },
            'searchString' : function(){
                for (var i = 0; i < this.searchOption.value.length; i++){
                    if(this.searchOption.selectedIndex != i || this.searchString == ''){
                        delete this.filter[this.searchOption.value[i]]
                    } else {
                        this.filter[this.searchOption.value[i]] = this.searchString;
                    }
                }
            },
        },
        mounted(){
            this.initialiseFilter();
            this.getVehicleType();
            this.getLocation();
            this.getColor();
            $('.form-control[readonly]').css('background-color' , '#DCDCDC')
            $('.reportrange-text').css('background-color' , '#DCDCDC')
        },
        methods : {
            
            initialiseFilter(){
                var keys = Object.keys(this.filter);
                let stringUrl = '?';
                var queryParams = this.filter;

                for(var i = 0 ; i < keys.length; i++){
                    if(!queryParams[keys[i]])
                        continue;

                    if((keys[i] == 'frame_no'  || keys[i] == 'type' || keys[i] == 'location') && queryParams[keys[i]] == '')
                        continue;
                    
                    // if(keys[i] == 'start_hour' || keys[i] == 'end_hour')
                    //     queryParams[keys[i]] += ":00";

                    stringUrl += `${keys[i]}=${queryParams[keys[i]]}&`;
                    
                }
                this.$store.state.filterUrl = stringUrl;
                this.filterReady = true;
            },
            search(){
                if(this.searchButton)
                    return;
                this.initialiseFilter();
                this.searchButton = true;
                this.$store.state.updateData++;
                this.searchButton = false;
            },
            getVehicleType(){
                this.$http.get('/api/vehicle/vehicle-type')
                .then((resp)=>{
                    this.filterOption.vehicleTypes = resp.data.data;
                })
                .catch((err)=>{
                    console.log(err);
                })
            },
            getLocation(){
                this.$http.get('/api/location/dso-location')
                .then((resp)=>{
                    this.filterOption.location = resp.data.data;
                })
                .catch((err)=>{
                    console.log(err);
                })
            },
            getColor(){
                this.$http.get('/api/color')
                .then((resp)=>{
                    this.filterOption.color = resp.data.data;
                })
                .catch((err)=>{
                    console.log(err);
                })
            }
        }
    }
</script>

<style>
    .form-control[readonly]{
        background-color: white;
    }
   
</style>

<style scoped>
    .searchOptions:hover{
        cursor:pointer;
    }
    .disabled-picker {
        opacity: 0.7;
        pointer-events: none;
       
    }
</style>